import { BodhiPlanner } from "@bodhistreams/ui";
import "./PlannerSection.css";

const CheckIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M5 13l4 4L19 7"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const BULLETS = [
	"Schedule music throughout the day",
	"Curate playlists for specific treatments",
	"Match music to different wellness experiences",
	"Create a consistent atmosphere across your facility",
];

const PlannerSection = () => (
	<section className="planner-section">
		<div className="planner-grid">
			<div className="planner-mockup-wrap">
				<BodhiPlanner />
			</div>

			<div>
				<span className="planner-copy-eyebrow">BodhiStreams Planner</span>
				<h2 className="planner-copy-heading">
					Take complete control of your daily music schedule.
				</h2>
				<p className="planner-copy-lead">
					Whether it's a morning yoga session, an afternoon massage, or an
					evening relaxation program — the right music is automatically prepared
					and ready to play, exactly when you need it.
				</p>
				<ul className="planner-bullets">
					{BULLETS.map((bullet) => (
						<li key={bullet} className="planner-bullet">
							<span className="planner-bullet-icon">
								<CheckIcon />
							</span>
							<span>{bullet}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	</section>
);

export default PlannerSection;